import React, { Fragment, useState } from "react";
import { Col, Card, Row, Button } from "reactstrap";
import { H4 } from "../../../AbstractElements";
import defaultUserImage from "../../../assets/images/user-profile/default-users.png";
import ProStaticWidgets from "./ProStaticWidgets ";
import SweetAlert from "sweetalert2";
import { useLocation, useNavigate } from "react-router";
import { activateCompany, suspendCompany } from "../../../CommonURL";
import { postDataWithToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import { selectRoleId } from "../../../Redux/personalDetail";

const CompanyProfile = (props) => {
  const personalDetails = props.details;
  const personalSingleDetail = props.personalData;
  const subscriptionData = props.subscription;
  const refreshData = props.refreshData;
  const refreshSubscription=props.refreshSubscription
  const roleId = useSelector(selectRoleId);


  const sub = subscriptionData?.[0]?.subscriptionStatus || "";

  const [userImage, setUserImage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const param1 = params.get("id");
  const industryId = params.get("industryId");

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setUserImage(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleActivate = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure?",
      text: "Activate this company?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
    });

    if (result.isConfirmed) {
      setLoading(true);

      const res = await postDataWithToken(activateCompany, {
        company_id: param1,
        industry_type_id: industryId,
      });

      if (res?.data?.status) {
        SweetAlert.fire("Success", "Activated", "success");
        refreshData();
        refreshSubscription()
      } else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }

      setLoading(false);
    }
  };

  const handleSuspend = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure?",
      text: "Suspend this company?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
    });

    if (result.isConfirmed) {
      setLoading(true);

      const res = await postDataWithToken(suspendCompany, {
        company_id: param1,
        industry_type_id: industryId,
      });

      if (res?.data?.status) {
        SweetAlert.fire("Success", "Suspended", "success");
        refreshData();
        refreshSubscription()
      } else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }

      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Col sm="12" md="12">
        <Card className="profile-header bg-size">
          <Row>
            <Col xl="5" sm="12" lg="5" md="12">
              <div className="userpro-box">
                <div className="img-wrapper">
                  <div className="master-avatar">
                    <img
                      className="step1"
                      alt="default-image"
                      src={userImage || defaultUserImage}
                    />
                  </div>

                  <div className="master-icon-wrapper">
                    <label htmlFor="fileInput">
                      <i className="icofont icofont-plus-circle"></i>
                    </label>
                    <input
                      type="file"
                      id="fileInput"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={handleFileSelect}
                    />
                  </div>
                </div>

                <div className="title" style={{ paddingBottom: "30px" }}>
                  <H4>{personalSingleDetail?.name}</H4>

                  <div className="user-info">
                    <p>
                      <strong>Email:</strong> {personalSingleDetail?.email}
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      {personalSingleDetail?.country_code}
                      {personalSingleDetail?.phone}
                    </p>
                    <span
                      style={{
                        padding: "5px 12px",
                        borderRadius: "20px",
                        color: "#fff",
                        backgroundColor:
                          sub === "active" ? "green" : "orange",
                      }}
                    >
                      {sub}
                    </span>
                     {roleId == 1&& (
                    <div style={{ marginTop: "10px" }}>
                      {sub === "active" ? (
                        <Button style={{ borderRadius:"9px" }} color="primary" onClick={handleSuspend}>
                          Change status
                        </Button>
                      ) : (
                        <Button color="primary" onClick={handleActivate}>
                          Change Status
                        </Button>
                      )}
                    </div>
                     )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs="12" sm="12" lg="7" className="personalBusinessDetails">
              <Row className="profileCards">
                <ProStaticWidgets details={personalDetails} />
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Fragment>
  );
};

export default CompanyProfile;